<template>
  <div class="app-layout">
    <HeaderComponent />
    <div class="main-container">
      <SideMenu />
      <div class="content-container">
        <main class="content">
          <slot></slot>
        </main>
      </div>
    </div>
    <FooterComponent>
      <slot name="footer-buttons"></slot>
    </FooterComponent>
    <LoadingOverlay />
  </div>
</template>

<script>
import HeaderComponent from '@/components/layout/Header.vue'
import SideMenu from '@/components/layout/SideMenu.vue'
import FooterComponent from '@/components/layout/Footer.vue'
import LoadingOverlay from '@/components/common/LoadingOverlay.vue'

export default {
  name: 'MainLayout',
  components: {
    HeaderComponent,
    SideMenu,
    FooterComponent,
    LoadingOverlay
  }
}
</script>

<style scoped>
.app-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow-x: hidden; /* Prevent horizontal scrolling */
}

.main-container {
  display: flex;
  flex: 1;
}

.content-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 100%;
  overflow-x: hidden;
}

.content {
  flex: 1;
  padding: 0.05rem;
  padding-bottom: 80px;
  background-color: var(--gray-light);
  overflow-y: auto;
  max-width: 100%;
}
</style>
